Ext.ns('mx.data');

/**
 * Checks the response for any errors, displays the if there are any.
 * @param resp - response from server to ajax request
 * @return boolean - returns true
 */
mx.data.displaySimpleErrors = function(resp) {
    var reader = new mx.data.JsonReader(
        {
            successProperty: 'success',
            root: 'rows',
        },
        mx.data.SimpleRecord
    );
    var o = reader.read(resp);

    if (o.errors.length > 0) {
        var errorMessages = [];
        for (var i = 0; i < o.errors.length; i++) {
            if (o.errors[i].message) {
                errorMessages.push(o.errors[i].message);
            }
        }
        Ext.Msg.show({
            msg: errorMessages.join('<br/>'),
            icon: Ext.Msg.ERROR,
            buttons: Ext.Msg.OK,
        });

        return true;
    } else {
        return false;
    }
};

mx.data.failure = function(response, o) {
    if (response.status == 403) {
        Ext.Msg.show({
            title: 'Error ' + (response.status > 0 ? response.status : ''),
            msg: response.statusText,
            icon: Ext.Msg.ERROR,
            buttons: Ext.Msg.OK,
        });
        mx.app.page.Main.prototype.handlers.logoutUser();
        return;
    }

    var responseText = response.responseText;
    if (window.stopShowErrors) {
        return;
    } else {
        window.stopShowErrors = true;
    }

    var data = responseText
        ? Ext.util.JSON.decode(response.responseText)
        : {
              message: 'Server timeout',
              stackTrace: '',
              scriptTrace: o,
          };

    var buttonAlign = 'center';

    var buttons = [
        {
            text: 'Ok',
            handler: function() {
                window.stopShowErrors = false;
                this.ownerCt.close();
            },
        },
    ];

    if (data.stackTrace || data.scriptTrace) {
        buttonAlign = 'right';
        buttons.push({
            text: 'Extra Information',
            handler: function() {
                var text = '';
                if (data.stackTrace) {
                    var errors = data.stackTrace;
                    errors.forEach(function(error) {
                        text +=
                            error.className +
                            '.' +
                            error.methodName +
                            ' (' +
                            error.fileName +
                            ':' +
                            error.lineNumber +
                            ')\n';
                    });
                }
                if (data.scriptTrace) {
                    for (var p in data.scriptTrace) {
                        if (typeof data.scriptTrace[p] == 'string') {
                            text += p + ' = ' + data.scriptTrace[p] + '\n';
                        }
                    }
                }

                new Ext.Window({
                    modal: true,
                    border: false,
                    bodyStyle: 'padding: 5;',
                    plain: true,
                    title: 'StackTrace',
                    width: 800,
                    height: 600,
                    layout: 'fit',
                    buttonAlign: 'right',
                    closable: true,
                    items: [
                        {
                            xtype: 'textarea',
                            value: text,
                        },
                    ],
                    buttons: [
                        {
                            text: 'Close',
                            handler: function() {
                                this.ownerCt.close();
                            },
                        },
                    ],
                }).show();
            },
        });
    }

    var form = new Ext.Window({
        id: 'store_error_window',
        resizable: false,
        modal: true,
        border: false,
        bodyStyle: 'padding: 5;',
        plain: true,
        title: 'Error ' + (response.status > 0 ? response.status : ''),
        width: 400,
        height: 120,
        y: 100,
        buttonAlign: buttonAlign,
        html:
            '<table width="100%" height="100%" border="0" style="font-size: 12px;">' +
            '<tr>' +
            '<td align="center">' +
            data.message +
            '</td>' +
            '</tr>' +
            '</table>',
        closable: true,
        buttons: buttons,
    });
    form.show();
};

mx.data.Store = function(config) {
    this.ajaxStubLatency = 1000;
    this.removeTimeout = 30000;

    Ext.apply(this, config);

    if (!config.customReader) {
        this.reader = new mx.data.JsonReader(
            {
                totalProperty: 'total',
                successProperty: 'success',
                root: 'rows',
            },
            this.record
        );
    } else {
        this.reader = new config['customReader'](
            {
                totalProperty: 'total',
                successProperty: 'success',
                root: 'rows',
                customParams: config['customReaderParams'],
            },
            this.record
        );
    }

    if (this.url) {
        this.proxy = new Ext.data.HttpProxy({url: mx.PATH + this.url});
    } else {
        this.proxy = new Ext.data.MemoryProxy({
            total: this.ajaxStubData.length,
            rows: this.ajaxStubData,
        });
        this.proxy.load = function() {
            Ext.data.MemoryProxy.prototype.load.defer(this.ajaxStubLatency, this.proxy, arguments);
        }.createDelegate(this);
    }

    this.groupOnSort = true;
    this.addEvents('recordchanged', 'removeRecords');
    mx.data.Store.superclass.constructor.call(this, config);
    Ext.apply(this.paramNames, {search: 'search', searchFields: 'fields'});
    this.on('update', function(ds, record, operation) {
        if (operation == Ext.data.Record.EDIT) {
            Ext.Ajax.request({
                url: mx.PATH + this.url,
                success: function(response) {
                    var o = this.reader.read(response);
                    if (o.success) {
                        record.data = o.records[0].data;
                        this.fireEvent('recordchanged', record, o.records[0]);
                        record.commit();

                        if (record.maskedElement && record.maskedElement.unmask) {
                            record.maskedElement.unmask();
                        }
                        var processResult = Ext.emptyFn;
                        var msgInfo = [];
                        if (o.infos.length) {
                            o.infos.forEach(function(i) {
                                msgInfo.push(i.message);
                            });
                            processResult = function() {
                                Ext.Msg.show({
                                    title: 'Info',
                                    msg: msgInfo.join('<br />'),
                                    icon: Ext.Msg.INFO,
                                    buttons: Ext.Msg.OK,
                                });
                            };
                        }
                        if (o.warnings.length) {
                            var msg = [];
                            o.warnings.forEach(function(i) {
                                msg.push(i.message);
                            });
                            Ext.Msg.show({
                                title: 'Warning',
                                fn: processResult,
                                msg: msg.join('<br />'),
                                icon: Ext.Msg.WARNING,
                                buttons: Ext.Msg.OK,
                            });
                        } else {
                            processResult();
                        }
                    } else {
                        var errors = o.errors;
                        if (!Ext.isArray(errors)) {
                            errors = [errors];
                        }
                        Ext.Msg.show({
                            title: 'Error',
                            msg: errors
                                .map(function(error) {
                                    return error.message;
                                })
                                .join('<br />'),
                            icon: Ext.Msg.ERROR,
                            buttons: Ext.Msg.OK,
                        });
                        record.reject();
                        if (record.maskedElement && record.maskedElement.unmask) {
                            record.maskedElement.unmask();
                        }
                    }
                },
                failure: function(response) {
                    if (record.maskedElement && record.maskedElement.unmask) {
                        record.maskedElement.unmask();
                    }
                    record.reject();
                    if (response.status == 403) {
                        mx.app.page.Main.prototype.handlers.logoutUser();
                    } else {
                        record.reject(); //todo: check if system works without errors
                        mx.data.failure(response);
                    }
                },
                scope: this,
                jsonData: this.modifyRecordOnUpdate(record),
            });
        }
    });

    this.on('remove', function(ds, record, index) {});
};

Ext.extend(mx.data.Store, Ext.data.GroupingStore, {
    modifyRecordOnUpdate: function(record) {
        return record.getData();
    },
    increaseTotalCount: function(delta) {
        this.totalLength = this.totalLength + delta;
    },
    createRecord: function(data, useReader) {
        data = data || {};
        this.add(useReader ? this.reader.readRecords({rows: [data]}).records[0] : new this.record(data));
    },
    remove: function(/*Array or Record*/ recs, collback) {
        var backFn = collback || Ext.emptyFn;
        if (!Ext.isArray(recs)) {
            recs = [recs];
        }
        var ids = [];
        for (var i = 0; i < recs.length; i++) {
            ids.push(recs[i].getRecordId ? recs[i].getRecordId() : recs[i]);
        }
        Ext.Ajax.request({
            url: mx.PATH + this.url + 'remove',
            method: 'POST',
            params: {ids: ids},
            timeout: this.removeTimeout,
            success: function(response) {
                backFn();
                var o = this.reader.read(response);
                var errorIds = [];
                if (!o.success) {
                    var errors = o.errors;
                    if (!Ext.isArray(errors)) {
                        errors = [errors];
                    }
                    errorIds = errors.map(function(error) {
                        return error.id;
                    });
                    var errorMsg = errors
                        .map(function(error) {
                            return error.message;
                        })
                        .join('<br />');

                    Ext.Msg.show({
                        title: 'Error',
                        msg: errorMsg.replace('com.magenta.maxoptra.exception.UIMessageException:', ''),
                        icon: Ext.Msg.WARNING,
                        buttons: Ext.Msg.OK,
                    });
                }
                this.reload();
                this.fireEvent('removeRecords', this, recs);
            },
            failure: function(response) {
                backFn();
                Ext.Msg.show({
                    title: 'Error ' + (response.status > 0 ? response.status : ''),
                    msg: response.statusText, //response.responseText - full response from server
                    icon: Ext.Msg.ERROR,
                    buttons: Ext.Msg.OK,
                });
            },
            scope: this,
        });
    },
    load: function(options, conn) {
        options = options || {};
        conn = conn || {};

        Ext.applyIf(conn, {method: 'GET'});
        if (this.fireEvent('beforeload', this, options) !== false) {
            this.storeOptions(options);
            var p = Ext.apply(options.params || {}, this.baseParams);
            if (this.sortInfo && this.remoteSort) {
                var pn = this.paramNames;
                p[pn['sort']] = this.sortInfo.field;
                p[pn['dir']] = this.sortInfo.direction;
            }
            this.proxy.on('loadexception', function(obj, options2, response, e) {
                mx.data.failure(response, options2);
            });
            this.proxy.load(p, this.reader, this.loadRecords, this, options, conn);
            return true;
        } else {
            return false;
        }
    },
    getFullRecords: function(callback, params, scope) {
        var url = this.url.endsWith('/') ? this.url : this.url + '/';
        this.proxy.load(
            params,
            this.reader,
            function(obj, options, success) {
                if (success) {
                    callback.call(scope || this, obj.records);
                }
            },
            this,
            null,
            {method: 'GET', url: mx.PATH + url}
        );
    },
    getFullRecord: function(recordId, callback, params, scope) {
        var url = this.url.endsWith('/') ? this.url : this.url + '/';
        this.proxy.load(
            params,
            this.reader,
            function(obj, options, success) {
                if (success) {
                    callback.call(scope || this, obj.records[0]);
                }
            },
            this,
            null,
            {method: 'GET', url: mx.PATH + url + recordId}
        );
    },
    setFilter: function(/* Object */ filter) {
        this.filterStore = filter;
        if (!this.baseParams) {
            this.baseParams = {};
        }
        if (filter) {
            for (var name in filter) {
                if (filter[name] && filter[name]['filterValue']) {
                    this.baseParams[name] = filter[name]['filterValue'];
                } else {
                    delete this.baseParams[name];
                }
            }
        }
    },
    resetFilter: function() {
        if (!this.filterStore) {
            return;
        }
        if (this.baseParams) {
            for (var name in this.filterStore) {
                delete this.baseParams[name];
            }
        }
        delete this.filterStore;
    },
    getFilter: function() {
        return this.filterStore || {};
    },

    getSearch: function() {
        var search = this.searchStore || {};
        search.remote = this.baseParams[this.paramNames.searchFields] && this.baseParams[this.paramNames.search];
        return search;
    },
    setSearch: function(/* Object */ search) {
        this.searchStore = search || {};
        if (!this.baseParams) {
            this.baseParams = {};
        }
        delete this.baseParams[this.paramNames.searchFields];
        delete this.baseParams[this.paramNames.search];
        if (this.lastOptions && this.lastOptions.params) {
            delete this.lastOptions.params[this.paramNames.searchFields];
            delete this.lastOptions.params[this.paramNames.search];
        }
        if (search.fields.length && search.value != '') {
            this.baseParams[this.paramNames.searchFields] = search.fields;
            this.baseParams[this.paramNames.search] = search.value;
        }
    },
    resetSearch: function() {
        if (this.searchStore) {
            if (this.baseParams) {
                delete this.baseParams[this.paramNames.searchFields];
                delete this.baseParams[this.paramNames.search];
            }
            delete this.searchStore;
        }
    },
});

mx.data.AjaxCore = Ext.extend(Ext.data.Connection, {
    request: function(o) {
        if (!o.failure) {
            o.failure = mx.data.failure;
        }
        return mx.data.AjaxCore.superclass.request.apply(this, arguments);
    },
});

mx.data.Ajax = new mx.data.AjaxCore();
